// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const isFirebaseEnabled = process.env.REACT_APP_DISABLE_FIREBASE !== 'true';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC3IkwYnAJ2_9AsoVLuq4RYG9hzLCPN1GE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "media-nov-react.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "media-nov-react",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "media-nov-react.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "869281956124",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:869281956124:web:97e46bb9ddbeb58bf6bad9",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-XXXXXXXXXX"
};

let app = null;
let db = null;
let analytics = null;

if (isFirebaseEnabled) {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);

  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
}

export { db, analytics };
export default app;
